import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { IChangeProductStatusRequest } from "../../../types/apis/products";

export const ChangeProductStauts = async (
  payload: IChangeProductStatusRequest,
  token: Token,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<
      any,
      GeneralResponse<IChangeProductStatusRequest>
    >({
      method: Methods.POST,
      endpoint: `${EndPoints.changeProductStatus}/${payload.productId}`,
      body: payload.StatusPayload,
      token,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useChangeProductStauts = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: IChangeProductStatusRequest; token: Token }
  > = useMutation({
    mutationFn: ({ payload, token }) => ChangeProductStauts(payload, token),
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
